import React from 'react';

import { BoldText } from './Components/ContractText';

interface PostcloseProps {
  postCloseOccupancyDays?: number;
  postCloseOccupancyRent?: number;
  postCloseOccupancyDeposit?: number;
  postCloseOccupancyTerms?: string;
}

const PostCloseOccupancy = ({
  postCloseOccupancyDays,
  postCloseOccupancyRent,
  postCloseOccupancyDeposit,
  postCloseOccupancyTerms,
}: PostcloseProps) => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Post-Close Occupancy
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside text-bold">
        <li>
          Buyer shall allow Seller to remain in the Property for up to{' '}
          <BoldText>{postCloseOccupancyDays}</BoldText> days after closing
          ("Post-Close Occupancy")
        </li>
        <li>
          Seller shall pay Buyer <BoldText>${postCloseOccupancyRent}</BoldText>{' '}
          per day for the Post-Close Occupancy.
        </li>
        <li>
          Seller shall pay Buyer a security deposit of{' '}
          <BoldText>${postCloseOccupancyDeposit}</BoldText> for the Post-Close
          Occupancy.
        </li>
        <li>
          Seller shall pay Buyer for any damages to the Property during the
          Post-Close Occupancy.
        </li>
        <li>
          Any futher terms relating to post-close occupancy are as follows:{' '}
          <BoldText>{postCloseOccupancyTerms}</BoldText>
        </li>
      </ol>
    </div>
  );
};

export default PostCloseOccupancy;
